import * as React from 'react';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
// import * as Firebase from 'firebase';
import { createStore, applyMiddleware } from 'redux';
// import { Route, Redirect, Switch } from 'react-router';
import { ConnectedRouter, routerMiddleware } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';
import { reducer } from './reducer';
import { rootSaga } from './sagas';
import Root from './root';
const history = createHistory();
const reduxRouterMiddleware = routerMiddleware(history);
// Hook sagas into redux
const sagaMiddleware = createSagaMiddleware();
const reduxStore = createStore(reducer, applyMiddleware(sagaMiddleware, reduxRouterMiddleware));
// Initialize sagas
sagaMiddleware.run(rootSaga);
class App extends React.Component {
    render() {
        return (React.createElement(Provider, { store: reduxStore },
            React.createElement(ConnectedRouter, { history: history },
                React.createElement(Root, null))));
    }
}
export default App;
export const service = {
    reduxStore,
};
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./src/app.js